import React from "react";
import UiIcon from "../../ui/icons/uiIcon";

export const showWizardStepDoneCheckMark = (wizardSelectedValue, featureGroup, cartItems, activeQuoteIndex, stepGroups) => {
  return stepGroups.some(stepGroup => {
    return (wizardSelectedValue && wizardSelectedValue.wizardGroup && (stepGroup.id === wizardSelectedValue.wizardGroup.id))
    || (featureGroup && cartItems.some(cartItem => {
        return stepGroup.id === cartItem.fromWizardGroupId
          && (cartItem.partId === featureGroup.partId)
          && (cartItem.currentQuote === activeQuoteIndex)
          && !cartItem.cartFeature.dbFeature.autoAddToCart
      }))
  })
}

const MaterialsWizardDoneCheckMark = () => {
  return (
    <div className="selection-footer-list__item-done selection-footer-list__item-done--svg">
      <UiIcon icon="checkmark" color="white"/>
    </div>
  )
};
export default MaterialsWizardDoneCheckMark
